import {configureStore} from "@reduxjs/toolkit";
import userReducer from "../../components/user/userSlice";
import flashMessagesReducer from "../../components/flash-message/flashMessagesSlice";

export default configureStore({
  reducer: {
    user: userReducer,
    flashMessages: flashMessagesReducer,
  },
});
